import { AppRoutingConstants } from "../../app-routing.constants";
export class GravesRoutingConstants {
    static GRAVES_ROUTE = AppRoutingConstants.createRouteToView("graves");
}
